module.exports = __webpack_public_path__ + "static/media/matilde-cap-greece-hello.ea9028a3.png";